import { news } from "../data";
import { ArrowUpRight } from "lucide-react";

export default function Newsroom() {
  return (
    <main data-testid="newsroom-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-16">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / newsroom / log
        </p>
        <h1 className="h-display text-5xl md:text-7xl max-w-[18ch]">
          Field <span className="text-signal-amber">notes.</span>
        </h1>
        <p className="mt-6 font-mono text-sm text-textmuted max-w-2xl leading-relaxed">
          Project completions, catalogue additions and milestones from our Patna
          and Pune offices.
        </p>
      </section>

      <section className="section-padding py-20">
        <div className="grid grid-cols-1 grid-cells">
          {news.map((n) => (
            <article
              key={n.code}
              className="p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-6 hover-lift"
              data-testid={`news-${n.code.toLowerCase()}`}
            >
              <div className="lg:col-span-2">
                <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-signal-amber">
                  {n.code}
                </p>
                <p className="font-mono text-xs text-textmuted mt-1">{n.date}</p>
              </div>
              <div className="lg:col-span-9">
                <h2 className="font-display font-bold text-2xl md:text-3xl leading-tight mb-3">
                  {n.title}
                </h2>
                <p className="font-mono text-sm text-textmuted leading-relaxed">{n.excerpt}</p>
              </div>
              <div className="lg:col-span-1 flex lg:justify-end">
                <ArrowUpRight size={20} className="text-textmuted" />
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
